import React, { useState } from 'react'
import { BaseForm } from './BaseForm/BaseForm.jsx'
import {
  getEmailServiceInquiries,
  getEmailSalesInquiries,
  getEmailFutureScholar,
  EMAIL_SERVICE_PROD,
  EMAIL_FUTURE_SCHOLAR_PROD,
} from '../../../global/environments/config'
import { postJsonRawResponse } from '../../../global/data/service'
import { Input, TextArea, InputGroup } from './formInputs/index.jsx'

const strings = {
  formId: 'ContactUsForm',
  fullName: 'Full name',
  email: 'Email address',
  phone: 'Phone number',
  message: 'Message',
  url: '/api/email',
}
const defaultErrors = {
  fullName: null,
  email: null,
  phone: null,
  message: null,
}

const checkEmailRerouting = (service, formData) => {
  const isServiceRequest =
    service.recipientEmail.includes(EMAIL_SERVICE_PROD) ||
    service.recipientEmail.includes(EMAIL_FUTURE_SCHOLAR_PROD)

  return {
    isService: isServiceRequest,
    from: isServiceRequest
      ? 'serviceinquiries@columbiathreadneedle.com'
      : formData.email,
    to: [service.recipientEmail],
  }
}

export function ContactUsForm() {
  const [userInput, setUserInput] = useState(defaultErrors)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [errors, setErrors] = useState({
    fullName: null,
    email: null,
    phone: null,
    message: null,
  })

  const createEmailPayload = (service, formData) => {
    const emailAddress = checkEmailRerouting(service, formData)

    return {
      type: 'email',
      data: {
        from: emailAddress.from,
        to: emailAddress.to,
        subject: service.subject,
        body: `From: ${formData.fullName} <br/> ${
          emailAddress.isService ? `Email: ${formData.email} <br/> ` : ''
        }Phone: ${formData.phone} <br/> Message: ${formData.message}`,
      },
    }
  }

  const configureForm = (serviceType) => {
    const EmailContactRecipients = {
      default: {
        recipientEmail: getEmailServiceInquiries(),
        subject: 'Contacting for Help',
        type: 'Contact Us By Email',
      },
      service_inquiries: {
        recipientEmail: getEmailServiceInquiries(),
        subject: 'Contacting for Help',
        type: 'Service inquiries',
      },
      product_inquiries: {
        recipientEmail: getEmailSalesInquiries(),
        subject: 'Contacting for Help',
        type: 'Product inquiries',
      },
      sales_inquiries: {
        recipientEmail: getEmailSalesInquiries(),
        subject: 'Contacting for Help',
        type: 'Sales/prospecting questions',
      },
      '529_FS': {
        recipientEmail: getEmailFutureScholar(),
        subject: 'Contacting for Help',
        type: '529 plan service inquiries',
      },
    }
    return EmailContactRecipients[serviceType] || EmailContactRecipients.default
  }

  const inputChangeHandler = (e, input) => {
    setUserInput({
      ...userInput,
      [input]: e.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    setErrors(defaultErrors)
    const e = {}
    const validationErrors = validate(userInput, validators)
    validationErrors.forEach((el) => {
      return (e[el] = true)
    })

    if (validationErrors.length) {
      setErrors(e)
    } else {
      const response = await postJsonRawResponse(
        strings.url,
        createEmailPayload(service, userInput)
      )
      setIsSuccess(response.ok)
      setIsSubmitted(true)
    }
  }

  const searchArray =
    window.location.search && window.location.search.split('=')
  const service = configureForm(searchArray.length > 1 && searchArray[1])

  const headline = (
    <div className="u-flex u-flexJustifyStart u-paddingVert10gu u-bgColorBrand">
      <h1 className="u-sizeConstrained u-textColorWhite">{service.type}</h1>
    </div>
  )

  const PHONE = 'phone'
  const FULL_NAME = 'fullName'
  const EMAIL = 'email'
  const MESSAGE = 'message'

  const validate = (input, validators) => {
    const invalid = Object.keys(input).filter((key) => {
      const value = input[key]
      return !value || validators[key]?.(value)
    })

    return invalid
  }

  const validators = {
    [PHONE]: (value) => {
      return value.replaceAll(/[^\d]/g, '').length !== 10
    },
    [EMAIL]: (value) => {
      return !/^\S+@\S+\.\S+$/.test(value)
    },
  }

  return (
    <BaseForm
      isSubmitted={isSubmitted}
      isSuccess={isSuccess}
      headline={headline}
    >
      <form onSubmit={(e) => handleSubmit(e)} id={strings.formId}>
        <div className="u-flex u-sm-flexCol">
          <div className="u-size1of2 u-sm-sizeFull u-paddingRight5gu u-sm-paddingRight0">
            <div className="u-marginTop3gu">
              <InputGroup
                name={strings.fullName}
                error={errors.fullName}
                onChange={(e) => {
                  inputChangeHandler(e, FULL_NAME)
                }}
                render={(props) => {
                  return <Input {...props} />
                }}
              />
            </div>
            <div className="u-marginTop3gu">
              <InputGroup
                name={strings.email}
                error={errors.email}
                errorMessage="Please enter a valid email address"
                onChange={(e) => {
                  inputChangeHandler(e, EMAIL)
                }}
                render={(props) => {
                  return <Input {...props} />
                }}
              />
            </div>
            <div className="u-marginTop3gu">
              <InputGroup
                name={strings.phone}
                error={errors.phone}
                onChange={(e) => {
                  inputChangeHandler(e, PHONE)
                }}
                render={(props) => {
                  return <Input {...props} />
                }}
              />
            </div>
          </div>
          <div className="u-size1of2 u-sm-sizeFull">
            <div className="u-marginTop3gu">
              <InputGroup
                name={strings.message}
                error={errors.message}
                onChange={(e) => {
                  inputChangeHandler(e, MESSAGE)
                }}
                render={(props) => {
                  return <TextArea {...props} />
                }}
              />
            </div>
          </div>
        </div>
        <div className="u-marginTop5gu">
          <button className="Button Button--primary" type="submit">
            Submit
          </button>
        </div>
      </form>
    </BaseForm>
  )
}
